import * as React from "react";
import Box from "@mui/material/Box";
import './manu.scss';
import DrawerMd from "./drawer-md";
import AppbarSmall from "./appbar";
import { useNavigate } from "react-router-dom";
import NestedRoutes from './routes'
import Footer from "../footer";

export default function Menu() {

  const navigate = useNavigate()

  const handleMenuClick = (link) => {
    navigate(".." + link, { replace: true });
  };

  return (
    <Box sx={{ display: { md: "flex" } }}>
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <DrawerMd handleMenuClick={handleMenuClick} />
      </Box>

      <Box sx={{ display: { md: "none" } }}>
        <AppbarSmall handleMenuClick={handleMenuClick} />
      </Box>

      <Box
        className="page-bg"
        component="main"
        sx={{ flexGrow: 1, p: 3, height: "100%" }}
      >
        <Box sx={{mb:10}}>
          <NestedRoutes />
        </Box>

        <Footer />
      </Box>
    </Box>
  );
}
